document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("featured-product-form")) {
    customElements.define(
      "featured-product-form",
      class FeaturedProductForm extends customElements.get("product-form") {
        constructor() {
          super();
          this.variantPicker = this.querySelectorAll(
            `[data-featured-product-variant-picker]`
          );
          this.variantPicker.forEach((picker) => {
            picker.addEventListener(
              "change",
              this.handleVariantChange.bind(this)
            );
          });
          this.sectionElement = this.querySelector(`product-form`);
        }
        handleVariantChange(evt) {
          this.updateFormInput(this.form, evt.target);
          this.handleOneTimePurchase(evt);
        }
        updateFormInput(form, target) {
          form.querySelector(`[name="id"]`).value = target.value;
          form.querySelector(`[name="selling_plan"]`).value = target.dataset.sellingPlanId;
        }
        handleOneTimePurchase(evt) {
          if (evt.target.dataset.firmhousePopup) {
            this.sectionElement.classList.add("hide-normal-buy-button");
          } else {
            this.sectionElement.classList.remove("hide-normal-buy-button");
          }
        }
        onSubmitHandler(evt) {
          super.onSubmitHandler(evt);
        }
        handleErrorMessage(errorMessage = false) {
          super.handleErrorMessage(errorMessage);
        }
      }
    );
  }
});
